// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Montserrat_fca8ee', '__Montserrat_Fallback_fca8ee'","fontStyle":"normal"},"className":"__className_fca8ee","variable":"__variable_fca8ee"};